export var Page;
(function (Page) {
    Page["DEFAULT_LOGO"] = "/logo.svg";
    Page["DEFAULT_LOGO_LIGHT"] = "/logo-light.svg";
    Page["DEFAULT_DESCRIPTION"] = "";
})(Page || (Page = {}));
